import { createTriggerStore } from "@utils/createTriggerStore";
import { AssociateInitiativesTriggerPayload } from "./types";

const store = createTriggerStore<AssociateInitiativesTriggerPayload>();

export const openAssociateInitiativesModal = store.open;
export const closeAssociateInitiativesModal = store.close;
export const useAssociateInitiativesTrigger = store.useTrigger;
